.input {
	/* "bg-depth2 border-2 w-full rounded-sm border-accent py-1.25 px-2 focus:outline-none focus:border-text" */
	width: 100%;
	max-width: 100%;
	border-radius: var(--rounded);
	background-color: var(--depth2);
	padding: 0.5rem;
}
.input:disabled {
	background-color: var(--depth3);
}
